const NON_FILTER_PARAMS = new Set(['search', 'sort', 'page', 'queryType']);
export function formatFiltersFromParams(params) {
  const allParams = params.getAll();
  const filters = [];
  for (const [field, values] of Object.entries(allParams)) {
    if (NON_FILTER_PARAMS.has(field)) continue;
    for (const value of values) {
      filters.push(`${field}__${value}`);
    }
  }
  return filters;
}

// AI-powered search types
export const AI_QUERY_TYPES = ['LLM', 'VAAS'];
// Type guard to identify AI-powered searches
export const isAiQueryType = type => AI_QUERY_TYPES.includes(type);

// Sort field for maintaining AI result order
export const ORDERED_LISTING_ID = 'ORDERED_LISTING_ID';
export const ASC = 'ASC';